import React from 'react';
import PropTypes from "prop-types";

const { UI } = Mobi2Go;

const DesktopView = (
    {
        hasJustOptedIn,
        checkboxState,
        checkboxDisabled,
        handleSubmit,
        optInString,
        optInLink,
        successMessage,
        CustomHtmlSlot,
    }) => {

    const handleOptInLinkKeyDown = e => {
        const enterKeyCode = 13;
        if (e.keyCode === enterKeyCode) {
            UI.trigger('showPolicy', 'loyalty')
        }
    };

    const className = name => `m2g-customer-loyalty-opt-in-checkbox${name || ''}`;

    return (
        <>
            {hasJustOptedIn // If a customer has just opted in display a success message, else display the opt-in checkbox
                ?
                    <div className={className('__success')}>
                            <span className={className('__success__text')}>
                                {successMessage}
                            </span>
                    </div>
                :
                    <div className={className('__container')}>
                        <label
                            htmlFor="loyalty-opt-in-checkbox"
                            data-loyalty-opt-in-checkbox-label
                            className={className('__label')}
                        >

                            {checkboxDisabled // If checkbox is disabled, display loading spinner in place of checkbox
                                ?
                                    <span
                                        className={className('__loading-spinner m2g-icon m2g-icon--spinner')}
                                    />
                                :
                                    <input
                                        id="loyalty-opt-in-checkbox"
                                        data-loyalty-opt-in-checkbox
                                        type="checkbox"
                                        className={className('__input m2g-input')}
                                        onChange={handleSubmit}
                                        checked={checkboxState}
                                        disabled={checkboxDisabled}
                                    />
                            }
                            {optInString}
                        </label>

                        {optInLink && // Displaying a link to trigger the loyalty policy is optional
                            <span
                                role='link'
                                tabIndex='0'
                                className={className('__link m2g-text--link')}
                                onClick={() => UI.trigger('showPolicy', 'loyalty')}
                                onKeyDown={(e) => handleOptInLinkKeyDown(e)}
                            >
                                    {optInLink}
                                </span>
                        }

                        {CustomHtmlSlot && // Displaying a CustomHtmlSlot is optional and allows us to display custom messaging with template variables
                            <CustomHtmlSlot slot="confirmation-loyalty-opt-in" />
                        }
                    </div>
            }
        </>
    );
};

DesktopView.propTypes = {
    hasJustOptedIn: PropTypes.bool.isRequired,
    checkboxState: PropTypes.bool.isRequired,
    checkboxDisabled: PropTypes.bool.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    optInString: PropTypes.string.isRequired,
    successMessage: PropTypes.string.isRequired,
    optInLink: PropTypes.string,
    CustomHtmlSlot: PropTypes.elementType,
}

export default DesktopView;
